import { render, staticRenderFns } from "./ShopPay.vue?vue&type=template&id=4d4de252&scoped=true"
import script from "./ShopPay.vue?vue&type=script&lang=js"
export * from "./ShopPay.vue?vue&type=script&lang=js"
import style0 from "./ShopPay.vue?vue&type=style&index=0&id=4d4de252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4de252",
  null
  
)

export default component.exports